//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var supportsSticky = (function () {
  if (typeof window === 'undefined') { return true }
  var supports = window.CSS && window.CSS.supports;
  if (!supports) { return false }
  return supports('position', 'sticky') || supports('position', '-webkit-sticky')
})();

var script = {
  name: 'StScrolly',
  props: {
    windowHeight: Number,
    windowTop: {
      type: Number,
      default: 0
    },
    triggerOffset: {
      type: Number,
      default: 0
    },
    dontUseSticky: Boolean
  },
  data: function data () {
    var windowHeight = this.windowHeight || 0;
    return {
      windowHeight_: windowHeight,
      slideHeights: [windowHeight],
      scrollPosition: -1
    }
  },
  computed: {
    scrollCheckpoints: function scrollCheckpoints () {
      return this.slideHeights.reduce(function (arr, h) {
        arr.push(arr[arr.length - 1] + h);
        return arr
      }, [0])
    },
    scrollLength: function scrollLength () {
      return this.scrollCheckpoints[this.scrollCheckpoints.length - 1]
    },
    active: function active () {
      var ref = this;
      var scrollPosition = ref.scrollPosition;
      return scrollPosition >= 0 && scrollPosition < this.scrollLength
    },
    exposedScope: function exposedScope () {
      var ref = this;
      var scrollPosition = ref.scrollPosition;
      var scrollCheckpoints = ref.scrollCheckpoints;
      var scrollLength = ref.scrollLength;
      var triggerOffset = ref.triggerOffset;
      var windowHeight_ = ref.windowHeight_;
      var offsetPosition = scrollPosition - triggerOffset;
      var slideIndex = scrollCheckpoints.filter(function (h) { return offsetPosition >= h; }).length - 1;
      var fromPrevSlide = offsetPosition < 0 ? Infinity
                          : offsetPosition - scrollCheckpoints[slideIndex];
      var toNextSlide = offsetPosition >= scrollLength ? Infinity
                        : scrollCheckpoints[slideIndex + 1] - offsetPosition;

      var enter = function (index, distance, offset) {
        if ( distance === void 0 ) distance = 0;
        if ( offset === void 0 ) offset = triggerOffset;

        if (index < 0) { index += scrollCheckpoints.length - 1; }
        var v1 = scrollCheckpoints[index];
        var v0 = v1 - distance;
        var v = scrollPosition - offset;
        if (distance === 0) { return v >= v1 ? 1 : 0 }
        return clampedInterpolate(v, v0, v1)
      };
      var exit = function (index, distance, offset) {
        if ( distance === void 0 ) distance = 0;
        if ( offset === void 0 ) offset = triggerOffset;

        if (index < 0) { index += scrollCheckpoints.length - 1; }
        var v0 = scrollCheckpoints[index + 1];
        var v1 = v0 - distance;
        var v = scrollPosition - offset;
        if (distance === 0) { return v >= v0 ? 0 : 1 }
        return clampedInterpolate(v, v0, v1)
      };

      function getProgress (start, end) {
        var progress = function (endEarly, offset) {
          if ( endEarly === void 0 ) endEarly = false;
          if ( offset === void 0 ) offset = triggerOffset;

          var v0 = scrollCheckpoints[start];
          var v1 = scrollCheckpoints[end] - (endEarly ? windowHeight_ : 0);
          var v = scrollPosition - offset;
          return clampedInterpolate(v, v0, v1)
        };
        progress.between = function (start, end) {
          if ( start === void 0 ) start = 0;
          if ( end === void 0 ) end = scrollCheckpoints.length - 1;

          if (start < 0) { start += scrollCheckpoints.length - 1; }
          if (end < 0) { end += scrollCheckpoints.length - 1; }
          return getProgress(start, end)
        };
        progress.at = function (index) {
          if (index < 0) { index += scrollCheckpoints.length - 1; }
          return getProgress(index, index + 1)
        };
        return progress
      }

      return {
        slideIndex: slideIndex,
        slideCount: scrollCheckpoints.length - 1,
        scrollPosition: scrollPosition,
        scrollLength: scrollLength,
        fromPrevSlide: fromPrevSlide,
        toNextSlide: toNextSlide,
        enter: enter,
        exit: exit,
        progress: getProgress(0, scrollCheckpoints.length - 1)
      }
    },
    stickyStyle: function stickyStyle () {
      var position = 'fixed';
      var top = this.windowTop + 'px';
      var bottom = 'auto';
      if (!this.dontUseSticky && supportsSticky) {
        position = ['-webkit-sticky', 'sticky'];
      } else if (this.scrollPosition < 0) {
        // align top
        position = 'absolute';
        top = '0';
      } else if (this.scrollPosition >= this.scrollLength - this.windowHeight_) {
        // align bottom
        position = 'absolute';
        top = 'auto';
        bottom = '0';
      }
      return {
        position: position,
        top: top,
        bottom: bottom,
        height: this.windowHeight ? (this.windowHeight + 'px') : '100vh'
      }
    }
  },
  methods: {
    scrollTo: function scrollTo (index, triggerBased) {
      if ( triggerBased === void 0 ) triggerBased = false;

      if (index < 0 || index > this.slideHeights.length) { return null }
      var initialPosition = window.scrollY + this.$el.getBoundingClientRect().top - this.windowTop;
      var targetOffsetPosition = this.scrollCheckpoints[index] + (triggerBased ? this.triggerOffset : 0);
      return initialPosition + targetOffsetPosition + 1
    },
    measure: function measure () {
      var $slides = this.$refs.slides.children;
      this.slideHeights = Array.prototype.map
        .call($slides, function (el) { return el.getBoundingClientRect().height; });
    },
    handleScroll: function handleScroll () {
      this.measure();
      this.scrollPosition = this.windowTop - this.$el.getBoundingClientRect().top;
    },
    handleResize: function handleResize () {
      this.measure();
      this.scrollPosition = this.windowTop - this.$el.getBoundingClientRect().top;
      this.windowHeight_ = this.windowHeight || window.innerHeight;
    }
  },
  mounted: function mounted () {
    this.handleResize();
    this.handleResize = frameRateLimited(this.handleResize);
    this.handleScroll = frameRateLimited(this.handleScroll);
    window.addEventListener('resize', this.handleResize, {capture: true, passive: true});
    window.addEventListener('scroll', this.handleScroll, {capture: true, passive: true});
  },
  beforeDestroy: function beforeDestroy () {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.handleScroll);
  }
};

function clamp (value, min, max) {
  return Math.min(Math.max(value, min), max)
}

function frameRateLimited (cb, context) {
  var ready = true;
  function wrapped () {
    var arguments$1 = arguments;
    var this$1 = this;

    if (!ready) { return }
    ready = false;
    window.requestAnimationFrame(function () {
      cb.apply(this$1, arguments$1);
      ready = true;
    });
  }
  return context ? wrapped.bind(context) : wrapped
}

function clampedInterpolate (v, v0, v1) {
  return Math.min(Math.max((v - v0) / (v1 - v0), 0), 1)
}

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

/* script */
var __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "st-scrolly", class: { active: _vm.active } },
    [
      _c("div", { staticClass: "background-container" }, [
        _c(
          "div",
          { staticClass: "background", style: _vm.stickyStyle },
          [_vm._t("background", null, null, _vm.exposedScope)],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { ref: "slides", staticClass: "slide-container" },
        [
          _vm._t(
            "default",
            [_c("div", { staticClass: "slide" })],
            null,
            _vm.exposedScope
          )
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "foreground-container" }, [
        _c(
          "div",
          { staticClass: "foreground", style: _vm.stickyStyle },
          [_vm._t("foreground", null, null, _vm.exposedScope)],
          2
        )
      ])
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var index = normalizeComponent_1(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

export default index;
export { clamp };
//# sourceMappingURL=index.js.map
